module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Black.b006f91ad943fcc749558afb0f50291d.eot";